module.exports = __webpack_public_path__ + "static/media/ecu.7f87d424.svg";